import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminTermsList from "@/features/terms/components/admin/AdminTermsList";
import { useTermsPermissions } from "@/pages/admin/terms";

export const Route = createFileRoute("/app/admin/terms/")({
  component: RouteComponent,
});

function RouteComponent() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const navigate = useNavigate();
  const { userCanEditAllTerms, userCanViewAllTerms } = useTermsPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Terms", link: null },
        ]}
      />
      <h1>Term Management</h1>
      <p>
        <Button
          color="primary"
          component={Link}
          to="/app/admin/terms/new"
          variant="contained"
          size="small"
          disabled={!userCanEditAllTerms}
        >
          Add Term
        </Button>
      </p>

      <AdminTermsList
        currentUser={currentUser}
        history={{ push: (path) => navigate({ to: path }) }}
        userCanEditAllTerms={userCanEditAllTerms}
        userCanViewAllTerms={userCanViewAllTerms}
      />
    </>
  );
}
